import React, { useState } from 'react';
import './styles/Login.css';
import { login } from '../services/api';
import { handleSuccessfulLogin } from '../utils/auth'; // ✨ NEW: Import from auth utils

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      console.log('🔐 Attempting login for user:', username);
      
      // ✨ SIMPLIFIED: Just call the API service
      const userData = await login({ username, password });
      
      // ✨ NEW: Use centralized login handler from auth utils
      handleSuccessfulLogin(userData, onLogin);
      
    } catch (err) {
      setError(err.message || 'An error occurred during login');
      console.error('❌ Login error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-form-container">
      <div className="login-logo">
        <img 
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBmPvafxPmDxB9QrpbSoRW3v0_KXiRdBY3ng&s" 
          alt="Company Logo" 
        />
      </div>
      <h1>Login</h1>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit} className="login-form">
        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            autoFocus
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button
          type="submit"
          className="login-button"
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
      </form>
      {/* <div className="login-footer">
        <a href="/forgot-password">Forgot Password?</a>
      </div> */}
      <div style={{
        marginTop: '28px',
        padding: '5px',
        borderTop: '1px solid #e0e0e0',
        textAlign: 'center',
        fontSize: '13px',
        color: '#666'
      }}>
        <a href="/privacy-policy" style={{ color: '#3498db', textDecoration: 'none', marginRight: '15px' }}>
          Privacy Policy
        </a>
        <a href="/terms-of-service" style={{ color: '#3498db', textDecoration: 'none', marginRight: '15px' }}>
          Terms of Service
        </a>
    
      </div>
      {/* <div style={{ marginTop: '18px', textAlign: 'center', fontSize: '13px', color: '#666'}}>
          <a href="/employee-manual" style={{ padding: '5px', marginBottom: '28px', color: 'var(--green-accent)', fontSize: '16px' }}>
          Employee Manual
        </a>
        <p>© 2026 DiNi Wigs. All rights reserved.</p>
      </div> */}
    </div>
  );
};

export default Login;